module.exports = __webpack_public_path__ + "8fabb900a6c11dc0474252588569dc66.svg";